import home from '@/language/en_US/home'
import industry from '@/language/en_US/industry'
import about from '@/language/en_US/about'
import jobs from '@/language/en_US/jobs'
import contact from '@/language/en_US/contact'
import cases from '@/language/en_US/cases'
import awards from '@/language/en_US/awards'
// 服務
import enterprise from '@/language/en_US/service/enterprise'
import businessProcess from '@/language/en_US/service/businessProcess'
import digital from '@/language/en_US/service/digital'
import enterpriseApplication from '@/language/en_US/service/enterpriseApplication'
import crm from '@/language/en_US/service/crm'

import blockchains from '@/language/en_US/service/blockchains'
import businessApplication from '@/language/en_US/service/businessApplication'
import dataAnalytics from '@/language/en_US/service/dataAnalytics'
import artificialIntelligence from '@/language/en_US/service/artificialIntelligence'

import softwareDevelopment from '@/language/en_US/service/softwareDevelopment'
import enterpriseMobility from '@/language/en_US/service/enterpriseMobility'
import cloud from '@/language/en_US/service/cloud'
import networkSecurity from '@/language/en_US/service/networkSecurity'
import globalization from '@/language/en_US/service/globalization'
import bigData from '@/language/en_US/service/bigData'
import internetThings from '@/language/en_US/service/internetThings'

import applicationOutsourcing from '@/language/en_US/service/applicationOutsourcing'
import businessProcessOutsourcing from '@/language/en_US/service/businessProcessOutsourcing'
import customerService from '@/language/en_US/service/customerService'
import humanResource from '@/language/en_US/service/humanResource'
export default {
  home,
  industry,
  about,
  jobs,
  contact,
  cases,
  awards,
  // 服務
  enterprise,
  businessProcess,
  digital,
  enterpriseApplication,
  crm,
  blockchains,
  businessApplication,
  dataAnalytics,
  artificialIntelligence,
  softwareDevelopment,
  enterpriseMobility,
  cloud,
  networkSecurity,
  globalization,
  bigData,
  internetThings,
  applicationOutsourcing,
  businessProcessOutsourcing,
  customerService,
  humanResource
}
